import styled from 'styled-components';

import { colors } from 'styles/theme/colors';

export type Counter = { label: string; value: string | number; sub?: string };

// The four-tile run counter strip (To send / Sent / Processed / Wave). Not in the design system yet.
export default function RunCounters({ counters }: { counters: Counter[] }) {
  return (
    <Strip aria-label='Run progress'>
      {counters.map((counter) => (
        <Tile key={counter.label}>
          <Key>{counter.label}</Key>
          <Value>{counter.value}</Value>
          {counter.sub && <Sub>{counter.sub}</Sub>}
        </Tile>
      ))}
    </Strip>
  );
}

const Strip = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
`;

const Tile = styled.div`
  background: ${colors.black3};
  border-radius: 8px;
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

const Key = styled.span`
  font-size: 12px;
  line-height: 20px;
  color: ${colors.black75};
`;

const Value = styled.span`
  font-size: 20px;
  line-height: 28px;
  font-weight: 500;
  font-variant-numeric: tabular-nums;
`;

const Sub = styled.span`
  font-size: 12px;
  line-height: 20px;
  color: ${colors.black75};
  font-variant-numeric: tabular-nums;
`;
